import { downloadFile } from '~libs/genericAction';
import { apiFormsImages } from '~constants/api';

/**
 * Resolves a `data-form-image` reference to an authenticated blob object URL. Shared by the
 * read-only view (`RichTextView`'s resolution effect) and the editor's image node view, so both
 * surfaces fetch and display an inserted image identically.
 *
 * Deliberately NOT an RTK Query endpoint. See `formImages.ts`'s docblock. `downloadFile` goes
 * through the same axios instance and interceptor (session cookie and signed proof) as every other authenticated
 * file read in this app (e.g. supplier invoices), so the request is authorised the same way.
 *
 * The caller owns the returned object URL's lifetime and must revoke it when done.
 */
export const fetchFormImageObjectUrl = (imageId: string): Promise<string> =>
  downloadFile(`${apiFormsImages}/${imageId}`, imageId);
